var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Chỉnh sửa thời gian gửi tin",
        visible: _vm.dialogVisible,
        width: "550px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "updateData", attrs: { model: _vm.fromData, rules: _vm.rules } },
        [
          _c(
            "div",
            [
              _c("el-time-picker", {
                staticStyle: { "margin-right": "5px" },
                attrs: {
                  clearable: false,
                  type: "time",
                  "value-format": "HH:mm",
                  format: "HH:mm",
                  "picker-options": {
                    selectableRange: "05:00:00 - 22:00:00",
                  },
                  placeholder: "Chọn thời gian",
                },
                model: {
                  value: _vm.fromData.time,
                  callback: function ($$v) {
                    _vm.$set(_vm.fromData, "time", $$v)
                  },
                  expression: "fromData.time",
                },
              }),
              _vm.typeDate.type != "attendanceArrive" &&
              _vm.typeDate.type != "attendanceLeave" &&
              _vm.typeDate.type != "attendanceEat" &&
              _vm.typeDate.type != "home" &&
              _vm.typeDate.type != "medicine" &&
              _vm.typeDate.type != "message" &&
              _vm.typeDate.type != "absent" &&
              _vm.typeDate.type != "birthday"
                ? _c(
                    "el-select",
                    {
                      staticClass: "input-time",
                      attrs: { clearable: "", placeholder: "Chọn ngày" },
                      model: {
                        value: _vm.fromData.day,
                        callback: function ($$v) {
                          _vm.$set(_vm.fromData, "day", $$v)
                        },
                        expression: "fromData.day",
                      },
                    },
                    _vm._l(_vm.dayList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: item.key },
                      })
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Trạng thái" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.fromData.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.fromData, "status", $$v)
                      },
                      expression: "fromData.status",
                    },
                  }),
                ],
                1
              ),
              _vm.typeDate.typeReceive == "plus" &&
              (_vm.typeDate.type == "fees" || _vm.typeDate.type == "salary")
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "percent", label: "Phần trăm (%)" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 1,
                          max: 100,
                          placeholder: "Nhập phần trăm",
                        },
                        model: {
                          value: _vm.fromData.percent,
                          callback: function ($$v) {
                            _vm.$set(_vm.fromData, "percent", $$v)
                          },
                          expression: "fromData.percent",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "danger",
                size: "medium",
                loading: _vm.loadingButtonDel,
              },
              on: {
                click: function ($event) {
                  return _vm.deleteDate("updateData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-delete" }),
              _c("span", [_vm._v("Xóa")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("updateData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("updateData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }